import React from 'react';
import { BadgeCheckIcon, StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
import { Eyebrow, Highlight, SectionTitle } from './ui/Section';
export function Testimonials() {
  return <section className="bg-blue-950 px-4 py-12 md:py-16" data-id="element-358" data-mp="3fym70jljx03t">
      <div className="mx-auto max-w-6xl" data-id="element-359" data-mp="3b0koq0vy94te">
        <Eyebrow onDark data-id="element-360" data-mp="3azjefymrcmcq">💬 Real homes, real decisions</Eyebrow>
        <SectionTitle onDark data-id="element-361" data-mp="36ypo6yluevgo">
          What women are saying about <Highlight data-id="element-362" data-mp="370aj4pc2kgf2">Clear the Clutter™</Highlight>
        </SectionTitle>

        <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-6" data-id="element-363" data-mp="31yuw4rqbzzu1">
          {testimonials.map((t, index) => <figure key={t.name} className={`flex flex-col rounded-2xl bg-white p-6 shadow-lg ${index < 2 ? 'lg:col-span-3' : 'lg:col-span-2'}`} data-id="element-364" data-mp="2x1bhvrtmvn23" data-mpi={index}>
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-365" data-mp="v85a7yk6bf3b">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-366" data-mp="q8ivfkop5qse" data-mpi={i} />)}
              </div>
              <p className="mt-3 text-lg font-black leading-tight text-blue-950" data-id="element-367" data-mp="m4rjfzcluq03">“{t.title}”</p>
              <blockquote className="mt-3 flex-1 text-sm font-medium leading-relaxed text-slate-600" data-id="element-368" data-mp="780ktsar9ibj">
                {t.quote}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-slate-200 pt-4" data-id="element-369" data-mp="c73rfh6dvwlm">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-amber-400 text-sm font-black text-blue-950" aria-hidden="true" data-id="element-370" data-mp="zx7sphw3nk9g">
                  {t.name.charAt(0)}
                </span>
                <span className="text-sm" data-id="element-371" data-mp="v4eocv4jmdxw">
                  <span className="flex items-center gap-1 font-black text-blue-950" data-id="element-372" data-mp="v3d1zui2u50v">
                    {t.name}, {t.age}
                    <BadgeCheckIcon className="h-4 w-4 text-emerald-700" aria-label="Verified buyer" data-id="element-373" data-mp="1nmk0qefoxma6" />
                  </span>
                  <span className="block font-semibold text-slate-500" data-id="element-374" data-mp="1xgpl3evlww9n">
                    {t.role} · {t.location}
                  </span>
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}